const productTabs = () => {
    const navBtns = document.querySelectorAll('.spt-nav-btn');
    const accBtns = document.querySelectorAll('.spt-acc-btn');

    if (!navBtns.length && !accBtns.length) return;

    const activate = (targetId) => {
        document.querySelectorAll('.spt-pane').forEach(p => p.classList.remove('is-active'));

        navBtns.forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
        });
        accBtns.forEach(b => {
            b.classList.add('collapsed');
            b.setAttribute('aria-expanded', 'false');
        });

        const pane = document.getElementById(targetId);
        if (pane) pane.classList.add('is-active');

        navBtns.forEach(b => {
            if (b.dataset.sptTarget === targetId) {
                b.classList.add('is-active');
                b.setAttribute('aria-selected', 'true');
            }
        });
        accBtns.forEach(b => {
            if (b.dataset.sptTarget === targetId) {
                b.classList.remove('collapsed');
                b.setAttribute('aria-expanded', 'true');
            }
        });
    };

    navBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            activate(this.dataset.sptTarget);
        });
    });

    accBtns.forEach(btn => {
        btn.addEventListener('click', function () {
            const id = this.dataset.sptTarget;
            const pane = document.getElementById(id);
            if (pane && pane.classList.contains('is-active')) {
                pane.classList.remove('is-active');
                this.classList.add('collapsed');
                this.setAttribute('aria-expanded', 'false');
            } else {
                activate(id);
            }
        });
    });
};

export default productTabs;
